export const messages = {
  title: { id: 'admin/promotions.form.conditions.affiliates.title' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.affiliates.view.title',
    },
  },
  editor: {
    description: {
      id: 'admin/promotions.form.conditions.affiliates.editor.description',
    },
    moreInformation: {
      id: 'admin/promotions.links.conditions.affiliates.more-information',
    },
    equals: {
      id: 'admin/promotions.form.utils.equals-to',
    },
    different: {
      id: 'admin/promotions.form.utils.different-from',
    },
  },
  validation: {
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    maxLowerThanEqualsMin: {
      id: 'admin/promotions.form.validation.max-lower-than-equals-min',
    },
    minGreaterThanEqualsMax: {
      id: 'admin/promotions.form.validation.min-greater-than-equals-max',
    },
  },
}
